import { render, staticRenderFns } from "./appointement.vue?vue&type=template&id=4b40fe49&"
import script from "./appointement.vue?vue&type=script&lang=js&"
export * from "./appointement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports